import { CloseOutlined } from '@ant-design/icons';
import { Waterbody } from '@omniafishing/core';
import { Skeleton } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useUser } from '../../../../hooks/use_user';
import { useUserWaterbodies } from '../../../../hooks/use_user_waterbodies';
import SvgLakes from '../../../svg/lakes';
import { MapLakeCard } from '../lakes_modal/map_lake_card';
import styles from './my_lakes_modal.less';

interface MyLakesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onWaterbodyClick: (waterbody: Waterbody) => void;
}

export const MyLakesModal = (props: MyLakesModalProps) => {
  const { isOpen, onClose, onWaterbodyClick } = props;

  const { userWaterbodies, userWaterbodiesFetchIsSuccess, userWaterbodiesFetchIsLoading } =
    useUserWaterbodies();
  const { user } = useUser();

  if (!isOpen) {
    return null;
  }

  const NoLakes = (
    <li className="flex flex-col items-center justify-center gap-1">
      <SvgLakes className="text-stone-400 text-2xl" />
      <p className="text-base font-medium">No Lakes Followed</p>
      <p>
        Follow your favorite waterbodies to make them easy to find. Access fishing reports, weather
        forecasts, solunar data, top-performing baits, and more.
      </p>
    </li>
  );

  return (
    <div className={classNames(styles.modal)}>
      <div className={styles.modalHeader}>
        <span className={styles.heading}>My Lakes</span>
        <CloseOutlined onClick={onClose} />
      </div>
      <div className={styles.modalContent}>
        <ol className={styles.reportList}>
          {!user ? (
            NoLakes
          ) : (
            <>
              {userWaterbodiesFetchIsLoading &&
                Array.from({ length: 6 }, (__, i) => (
                  <Skeleton active key={i} paragraph={{ rows: 4 }} />
                ))}
              {userWaterbodiesFetchIsSuccess &&
                (userWaterbodies.length === 0
                  ? NoLakes
                  : userWaterbodies.map((waterbody) => {
                      return (
                        <li key={waterbody.id}>
                          <MapLakeCard waterbody={waterbody} onClick={onWaterbodyClick} />
                        </li>
                      );
                    }))}
            </>
          )}
        </ol>
      </div>
    </div>
  );
};
